class LoginRequiredModal extends HTMLElement {
  constructor() {
    super();

    if (this.querySelector('.modal__close')) {
      const buttons = this.querySelectorAll('.modal__close');
      for(let i=0; i<buttons.length; i++) {
        buttons[i].addEventListener('click', function(e) {
          const modal = e.target.closest('.modal');
          modal.removeAttribute('open');
          modal.setAttribute('aria-hidden', 'true');
        });
      }
    }
  }

  open() {
    const modal = this.querySelector('.modal');
    modal.setAttribute('open', true);
    modal.setAttribute('aria-hidden', 'false');
  }

  close() {
    const modal = this.querySelector('.modal');
    modal.removeAttribute('open');
    modal.setAttribute('aria-hidden', 'true');
  }

  isOpen() {
    return this.querySelector('.modal').hasAttribute('open');
  }
}

customElements.define('login-required-modal', LoginRequiredModal);
